import { render, staticRenderFns } from "./SharedLinkList.vue?vue&type=template&id=31bb7b52&scoped=true"
import script from "./SharedLinkList.vue?vue&type=script&lang=ts"
export * from "./SharedLinkList.vue?vue&type=script&lang=ts"
import style0 from "./SharedLinkList.vue?vue&type=style&index=0&id=31bb7b52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bb7b52",
  null
  
)

export default component.exports